import {
  AccountAdminClient,
  AccountNotifications,
  AccountResponse,
} from "lib/ShiOneClient";
import { ApiClientConfig } from "../auth/ApiClientConfig";
const api = new AccountAdminClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

export async function getRestAccounts(): Promise<AccountResponse> {
  return api.getAccounts();
}

export async function getRestAccountNotifications(): Promise<AccountNotifications> {
  return api.getAccountNotifications();
}

